import { BaseType, BaseTypeLiterals } from "../../../domain/base/base-type";

const TabsStateLiteralList = [
  "BASIC",
  "FORM",
  "AUTH_LEVEL",
  "PAYMENT",
  "CUSTOM_UI",
  "NOTIFICATION_MAIL",
  "QUOTA",
  "INTERNAL_WORK",
  "REPORT_OUTPUT",
] as const;

type TabsStateLiterals = (typeof TabsStateLiteralList)[number];

export type TabStateMatcher<R> = BaseTypeLiterals<TabsStateLiterals, R>;

/**
 * 画面の表示状態を表す
 */
export class TabState extends BaseType<TabsStateLiterals> {
  static isValid(tab?: string): tab is TabsStateLiterals {
    return TabsStateLiteralList.indexOf(tab as TabsStateLiterals) !== -1;
  }

  static from(tab: TabsStateLiterals) {
    return new TabState(tab);
  }

  static initialize() {
    return new TabState("BASIC");
  }

  static form() {
    return new TabState("FORM");
  }

  static authLevel() {
    return new TabState("AUTH_LEVEL");
  }

  static payment() {
    return new TabState("PAYMENT");
  }

  static formFunnel() {
    throw new Error(`Not supported yet.`);
  }

  static customUi() {
    return new TabState("CUSTOM_UI");
  }

  static notificationMail() {
    return new TabState("NOTIFICATION_MAIL");
  }
  static quota() {
    return new TabState("QUOTA");
  }

  static internalWork() {
    return new TabState("INTERNAL_WORK");
  }

  static reportOutput() {
    return new TabState("REPORT_OUTPUT");
  }
}
